import './online.css'

export default function Online({user}) {
  const SF = process.env.REACT_APP_SERVER_FOLDER
  return (
    <li className="rightbarFriend">
      <div className="rightbarProfileImgContainer">
        <img className="rightbarProfileImg" src={SF+"public/"+user.profilePicture} alt="" />
        <span className="rightbarOnline" ></span>
      </div>
      <span className="rightbarUsername">{user.username}</span>
    </li>
  )
}
